module.exports = "/dashboard/manage/users/verify-to-invite-tooltip-f49cb3.html";